import * as types from "./breadcrumb.actionsType";
import actions from "./breadcrumb.actions";
import {
  getCurrentRoute
} from "@common/router/router";

import _ from "lodash";

import {
  takeEvery,
  put
} from "redux-saga/effects";

export default workSaga;

function* workSaga() {
  yield takeEvery(types.SET_CURRENT_BREADCRUMB, setCurrentBreadcrumb);
}

function* setCurrentBreadcrumb(action) {
  const {
    payload
  } = action;

  const route = getCurrentRoute();
  if (!route || !route.breadCrumb){
    yield put(actions.setStateBreadcrumb(undefined));
    console.error("Não foi encontrado o breadcrumb.");
  } 
  else {
    const currentBreadcrumb = _.isArray(route.breadCrumb) ? route.breadCrumb : route.breadCrumb[payload];
    yield put(actions.setStateBreadcrumb(currentBreadcrumb));
  };
}
